<div class="contenedor-carta-director">
  <div class="header-carta-director">
    <img src="assets/images/cartadirector.webp" alt="carta del director" loading="lazy" width="100%" height="100%" />
    <h1 class="titulo">{{ noticia?.tituloVideo }}</h1>
  </div>
  <div class="cuerpo-carta-director">
    <div class="noticia" [innerHTML]="noticia?.descripcionVideo"></div>
  </div>
  <div class="bloque-mas-cartas"></div>
</div>
